import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useFunctionalTitles from '@hooks/useFunctionalTitles';

const buildFilterChips = ({ member, functionalTitles }) => {
    const chips = [];

    if (member.company?.primaryBusinessType) {
        chips.push(member.company.primaryBusinessType.name);
    }

    if (member.company?.secondaryBusinessTypes?.length) {
        member.company.secondaryBusinessTypes.forEach(type => {
            chips.push(type.name);
        });
    }

    if (member.functionalTitle) {
        const title = functionalTitles.__type.enumValues.find(value => value.name === member.functionalTitle);

        if (title?.description) {
            chips.push(title.description);
        }
    }

    return chips;
};

// member could be viewer
const useMembersLikeMeFilterChips = ({ member }) => {
    const [filterChips, setFilterChips] = useState('');
    const { data: functionalTitles } = useFunctionalTitles();

    useEffect(() => {
        if (!member || !functionalTitles) {
            return;
        }

        setFilterChips(buildFilterChips({ member, functionalTitles }));
    }, [member, functionalTitles]);

    return { filterChips };
};

useMembersLikeMeFilterChips.propTypes = {
    member: PropTypes.object,
};

export default useMembersLikeMeFilterChips;
